export enum ReasonCodeEntityClass {
  ProgramPeriod = 'ProgramPeriod',
  ProgramPeriodConfig = 'ProgramPeriodConfig',
}

export enum ReasonCodePrimaryType {
  AuditActionReason = 'AuditAction',
  AuditRejectReason = 'AuditEntryRejectReason',
  FormQualityReason = 'FormQualitySectionReason',
  FormRiskReason = 'FormRiskEntryReason',
  FormRiskActionReason = 'FormRiskActionReason',
  FormStatusReason = 'FormStatus',
}
